import { Box, Button, Typography } from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import { muiStyles } from './Header.styles';
import { IPublication } from '@opengov/stories-shared/types';
import React from 'react';

import { storiesPage as messages } from '../../../../locale/stories.en.locale.json';

export interface IHeaderProps {
  children: React.ReactNode;
  isAdmin: boolean;
  canEdit?: boolean;
  publication?: IPublication;
  breadcrumbs?: string[];
  isSettingsPage?: boolean;
  displayPublicationTab?: boolean;
  canExport?: boolean;
  storiesAccessControlEnabled?: boolean;
  onEditClick?(): void;
  navigateToStoryList?(): void;
  navigateToPublicationView?(): any;
  navigateToPublicationList?(): any;
}

export const handleStoryNavigationClick = (event: React.MouseEvent<HTMLElement>, navigateToStoryList) => {
  event.preventDefault();
  navigateToStoryList();
};
export const handlePublicationNavigationClick = (event: React.MouseEvent<HTMLElement>, navigateToPublicationView) => {
  event.preventDefault();
  navigateToPublicationView();
};

export const Header: React.FC<IHeaderProps> = ({
  children,
  breadcrumbs,
  publication,
  isSettingsPage = false,
  displayPublicationTab = false,
  isAdmin,
  canEdit,
  canExport,
  storiesAccessControlEnabled,
  onEditClick,
  navigateToStoryList,
  navigateToPublicationView,
  navigateToPublicationList
}) => {
  return (
    <Box component="header" sx={muiStyles.root}>
      <Box sx={muiStyles.headerContent}>
        <Box sx={muiStyles.breadCrumbsContainer} data-test="header-breadcrumbs">
          <Typography
            component="a"
            href=""
            className="ui-breadcrumbs__item"
            sx={muiStyles.breadcrumbsLink}
            data-test="storyList-breadcrumbs-link"
            onClick={(event: React.MouseEvent<HTMLElement>) => {
              !!publication?.id
                ? handleStoryNavigationClick(event, navigateToPublicationList)
                : handleStoryNavigationClick(event, navigateToStoryList);
            }}
          >
            {displayPublicationTab ? messages.storiesAndPublications : messages.title}
          </Typography>

          {publication?.title && (
            <Typography
              component="a"
              href=""
              className="ui-breadcrumbs__item"
              sx={muiStyles.breadcrumbsLink}
              data-test="publications-breadcrumbs-link"
              onClick={(event: React.MouseEvent<HTMLElement>) => handlePublicationNavigationClick(event, navigateToPublicationView)}
            >
              {publication.title}
            </Typography>
          )}

          {breadcrumbs &&
            breadcrumbs.map(
              (text, idx) =>
                text && (
                  <Typography key={idx} component="span" className="ui-breadcrumbs__item" sx={muiStyles.titleStyle}>
                    {text}
                  </Typography>
                )
            )}
        </Box>
        <Box sx={muiStyles.titleContainer}>
          <Box component="nav" aria-label="Story breadcrumbs" sx={muiStyles.titleText} data-test="story-breadcrumbs-navigation">
            <Box sx={muiStyles.publicationTitle}>
              <Typography variant="h2" sx={muiStyles.storyTitle}>
                {breadcrumbs[0]}
              </Typography>
            </Box>
          </Box>
          <Box
            sx={!!isSettingsPage ? muiStyles.settingsButtonContainer : muiStyles.buttonContainer}
            data-test="action-button-container"
          >
            {!isSettingsPage && !!breadcrumbs[0] && (isAdmin || (storiesAccessControlEnabled && canEdit)) && (
              <Button
                className="ui-breadcrumbs__item"
                size="small"
                variant="text"
                color="primary"
                aria-label="edit"
                data-test="story-edit-button"
                startIcon={<EditOutlinedIcon fontSize="small" aria-hidden={true} />}
                sx={muiStyles.editButton}
                onClick={() => onEditClick?.()}
              >
                {messages.edit}
              </Button>
            )}
            {!!breadcrumbs[0] && (
              <Box sx={canExport ? muiStyles.actionContainerOnlyExport : muiStyles.actionContainer}>{children}</Box>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
